import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
  output,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  Close20IconComponent,
  HeadlineComponent,
} from '@zeiss/beyond-online-angular';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.html',
  styleUrl: './dialog.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    Close20IconComponent,
    HeadlineComponent,
    TranslocoModule,
  ],
  host: {
    class: 'dialog',
    '[class.open]': 'isOpen()',
    '(click)': 'onBackdropClick()',
    '[class.s]': "size() === 's'",
    '[class.m]': "size() === 'm'",
    '[class.l]': "size() === 'l'",
    '[class.full]': "size() === 'full'",
  },
})
export class Dialog {
  isOpen = model<boolean>(false);
  title = input<string>('');
  close = output<void>();
  size = input<'s' | 'm' | 'l' | 'full'>();

  closeDialog() {
    this.isOpen.set(false);
    this.close.emit();
  }

  onBackdropClick() {
    this.closeDialog();
  }
}
